var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 4H11.3333V2H4.66667V4ZM4.66667 6.66667H11.3333V14H4.66667V6.66667ZM2 6H3.33333V6.66667V14C3.33333 14.7364 3.93029 15.3333 4.66667 15.3333H11.3333C12.0697 15.3333 12.6667 14.7364 12.6667 14V6.66667V6H14V4.66667H2V6ZM6 8V12.6667H7.33333V8H6ZM8.66667 8V12.6667H10V8H8.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.1be0076f10d2e6f475aecf11f2a01bda.svg";
export { ForwardRef as ReactComponent };